<template>
  <svg
    :class="color"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="14"
    viewBox="0 0 24 14"
  >
    <path
      class="a"
      id="show-white"
      d="M24,14s-5.025,7-12,7S0,14,0,14,5.025,7,12,7,24,14,24,14ZM12,9.333A4.586,4.586,0,0,0,7.5,14,4.586,4.586,0,0,0,12,18.667,4.586,4.586,0,0,0,16.5,14,4.586,4.586,0,0,0,12,9.333Zm0,2.333A2.335,2.335,0,1,0,14.25,14,2.293,2.293,0,0,0,12,11.667Z"
      transform="translate(0 -7)"
      fill="#2d323c"
    />
  </svg>
</template>

<script>
export default {
  name: 'Watch',
  props: ['color'],
}
</script>

<style lang="scss" scoped>
.grass {
  .a {
    fill: $grass;
  }
}
.ocean {
  .a {
    fill: $ocean;
  }
}
.sunset {
  .a {
    fill: $sunset;
  }
}
</style>
